"use client"
import React,{useEffect,useRef,useState} from 'react'
import Footer from '../components/Footer';
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import EarthingBanner from '../components/EarthingBanner';
import { ProductProvider } from '../components/Productcontext';
import banner1 from '../images/whypage/why_banner.jpg';
import banner1_2x from '../images/whypage/why_banner@2x.jpg';
import WhypageContent from '../components/WhypageContent';
import ScrollToTopButton from '../components/ScrollToTopButton';
import Installation from '../components/Installation';
import DesignCommissionContent from '../components/DesignCommissionContent';
// import { useLocation } from 'react-router-dom';

export default function Ourservices() {
    const installRef = useRef(null);
    const soilRef = useRef(null);
    const designRef = useRef(null);
    const [currentHash, setCurrentHash] = useState('');
    const displline=true;
    const helmetContext = {};
    useEffect(() => {
        setCurrentHash(window.location.hash);
    //     console.log('Current hash:', location.hash);
    // console.log('Install Ref:', installRef.current);
    // console.log('Soil Ref:', soilRef.current);
    // console.log('Design Ref:', designRef.current);

    if (installRef.current && location.hash === '#install') {
      console.log("Matched #install");
      installRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (soilRef.current && location.hash === '#soil') {
      console.log("Matched #soil");
      soilRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (designRef.current && location.hash === '#design') {
      console.log("Matched #design");
      designRef.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.log("No match found for hash");
    }
    const updateHash = () => {
        setCurrentHash(window.location.hash);
      };
  
      // Listen to hash changes
      window.addEventListener('hashchange', updateHash);
  
      // Cleanup the event listener on component unmount
      return () => {
        window.removeEventListener('hashchange', updateHash);
      };

      }, []);

    return (
        <div>
           <ProductProvider>
            {/* <PreHeader/>
            <Header/>
            <Menu/> */}
            <div id="install" ref={installRef}>
                <Installation id="install" ref={installRef}/>
            </div>
            {/* <div id="soil" ref={soilRef}>
                <Installation id="soil" ref={soilRef}/>
            </div> */}
            <div id="design" ref={designRef}>
                <DesignCommissionContent />
            </div>
            <ScrollToTopButton/>
           
                
            
            <Footer linedisp={displline}/>
            </ProductProvider>
        </div>
    )

}